export const articlesCategoriesContext = {
  getCategoriesArticles: '/article-service/api/external/categories',
  updateCategoriesArticles: '/article-service/api/external/categories/{id}',
  image: '/article-service/api/external/categories/{id}/image',
  createCategoriesArticles: '/article-service/api/external/categories',
};
